(function(window, document) {
  if (window.__auxitoQuickshopCartBridgeLoaded) return;
  window.__auxitoQuickshopCartBridgeLoaded = true;

  var OVERLAY_ID = "auxito-quickshop-cart-loading-overlay";
  var STYLE_ID = "auxito-quickshop-cart-bridge-style";
  var PENDING_ATTR = "data-auxito-quickshop-cart-pending";

  function matches(el, selector) {
    if (!el || el.nodeType !== 1) return false;
    var fn = el.matches || el.msMatchesSelector || el.webkitMatchesSelector;
    return fn ? fn.call(el, selector) : false;
  }

  function isTargetPage() {
    if (!document.body || !document.body.classList) return false;
    return document.body.classList.contains("template-index") || document.body.classList.contains("template-collection");
  }

  function wait(ms) {
    return new Promise(function(resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function ensureStyles() {
    var style;
    if (document.getElementById(STYLE_ID)) return;
    style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = [
      "#" + OVERLAY_ID + "{position:fixed;inset:0;z-index:999999;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,.45);opacity:1;transition:opacity .3s ease;pointer-events:none;}",
      "#" + OVERLAY_ID + ".auxito-quickshop-cart-loading--fade{opacity:0;}",
      "#" + OVERLAY_ID + " .auxito-quickshop-cart-loading__spinner{width:44px;height:44px;border:4px solid rgba(17,17,17,.16);border-top-color:#111;border-radius:50%;animation:auxito-quickshop-cart-spin .8s linear infinite;}",
      "@keyframes auxito-quickshop-cart-spin{to{transform:rotate(360deg);}}"
    ].join("");
    document.head.appendChild(style);
  }

  function showCartTransitionOverlay() {
    var existing = document.getElementById(OVERLAY_ID);
    var overlay = document.createElement("div");
    var removed = false;
    var observer;

    ensureStyles();
    if (existing) existing.remove();
    overlay.id = OVERLAY_ID;
    overlay.innerHTML = '<div class="auxito-quickshop-cart-loading__spinner"></div>';
    document.body.appendChild(overlay);

    function remove() {
      if (removed) return;
      removed = true;
      overlay.classList.add("auxito-quickshop-cart-loading--fade");
      window.setTimeout(function() {
        if (overlay.parentNode) overlay.remove();
      }, 300);
    }

    observer = new MutationObserver(function() {
      if (document.querySelector("[data-atc-banner][data-flyout-active]")) {
        observer.disconnect();
        remove();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [ "data-flyout-active" ]
    });
    window.setTimeout(function() {
      observer.disconnect();
      remove();
    }, 8000);

    return remove;
  }

  function getQuickshopAtcButton(form, event) {
    var button = event && event.target && event.target.closest ? event.target.closest("[data-product-atc]") : null;
    return button && form.contains(button) ? button : form.querySelector("[data-product-atc]");
  }

  function isQuickshopForm(form) {
    var formArea;
    if (!isTargetPage()) return false;
    if (!form || !matches(form, "[data-product-form]")) return false;
    formArea = form.closest("[data-product-form-area]");
    return !!(formArea && formArea.querySelector("[data-product-quickshop-message]"));
  }

  function getProductFormData(form) {
    if (typeof window.FormData === "function") {
      return new window.FormData(form);
    }
    if (window.jQuery) {
      return window.jQuery(form).serializeArray();
    }
    return {};
  }

  function formDataHasVariantId(formData) {
    var hasId = false;
    if (formData && typeof formData.get === "function") {
      return !!String(formData.get("id") || "").trim();
    }
    if (Object.prototype.toString.call(formData) === "[object Array]") {
      formData.forEach(function(entry) {
        if (entry && entry.name === "id" && String(entry.value || "").trim()) hasId = true;
      });
      return hasId;
    }
    return !!(formData && String(formData.id || "").trim());
  }

  function setQuickshopMessage(form, message) {
    var formArea = form ? form.closest("[data-product-form-area]") : null;
    var target = formArea ? formArea.querySelector("[data-product-quickshop-message]") : null;
    var errorEl;
    if (!target) return;
    if (!message) {
      target.innerHTML = "";
      target.classList.remove("visible");
      return;
    }
    errorEl = document.createElement("div");
    errorEl.className = "product-message--error";
    errorEl.textContent = String(message);
    target.innerHTML = "";
    target.appendChild(errorEl);
    target.classList.add("visible");
  }

  function getCartErrorMessage(error) {
    if (!error) return "Unable to add this item to cart.";
    if (typeof error === "string") return error || "Unable to add this item to cart.";
    if (error.status === 0) return "Unable to add this item to cart. Please try again.";
    if (error.message) return String(error.message);
    if (error.description) return String(error.description);
    if (error.statusText && error.statusText !== "error") return String(error.statusText);
    return "Unable to add this item to cart.";
  }

  function setButtonPending(button, pending, wasDisabled) {
    if (!button) return;
    button.classList.toggle("processing", !!pending);
    if (pending) {
      button.setAttribute(PENDING_ATTR, "true");
      button.setAttribute("aria-busy", "true");
      button.setAttribute("aria-disabled", "true");
      button.disabled = true;
      return;
    }
    button.removeAttribute(PENDING_ATTR);
    button.removeAttribute("aria-busy");
    button.removeAttribute("aria-disabled");
    button.disabled = !!wasDisabled;
  }

  function closeQuickshop(form) {
    var modal = form ? form.closest("[data-modal-container]") : document.querySelector("[data-modal-container]");
    var closeButton = modal ? modal.querySelector("[data-modal-close]") : null;
    if (closeButton && typeof closeButton.click === "function") {
      closeButton.click();
    }
  }

  function openCartDrawerDirect(trigger) {
    var cartService = window.Auxito && window.Auxito.CartService;
    var headerButton;

    if (cartService && typeof cartService.fetchCart === "function" && typeof cartService.openCart === "function") {
      return cartService.fetchCart(true).then(function(cart) {
        return cartService.openCart(cart, trigger || null);
      });
    }

    headerButton = document.querySelector(".site-header-cart--button.js-site-header-cart--button");
    if (headerButton && typeof headerButton.click === "function") {
      headerButton.click();
      return Promise.resolve();
    }
    window.location.href = "/cart";
    return Promise.resolve();
  }

  function handleQuickshopAtc(form, event) {
    var cartService = window.Auxito && window.Auxito.CartService;
    var button = getQuickshopAtcButton(form, event);
    var wasDisabled;
    var formData;
    var removeLoading;

    if (!button || !cartService || typeof cartService.postCartAdd !== "function") return false;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }
    if (button.disabled || button.classList.contains("disabled")) return true;
    if (button.getAttribute(PENDING_ATTR) === "true") return true;

    formData = getProductFormData(form);
    if (!formDataHasVariantId(formData)) return true;

    wasDisabled = button.disabled;
    setButtonPending(button, true, wasDisabled);
    setQuickshopMessage(form, "");
    removeLoading = showCartTransitionOverlay();

    cartService.postCartAdd(formData).then(function() {
      closeQuickshop(form);
      return wait(120);
    }).then(function() {
      return openCartDrawerDirect(button);
    }).then(function() {
      setButtonPending(button, false, wasDisabled);
    }, function(error) {
      if (typeof removeLoading === "function") removeLoading();
      setButtonPending(button, false, wasDisabled);
      setQuickshopMessage(form, getCartErrorMessage(error));
      console.warn("[auxito-quickshop-cart-bridge] Quickshop add to cart failed.", error);
    });

    return true;
  }

  document.addEventListener("click", function(event) {
    var button = event.target && event.target.closest ? event.target.closest("[data-product-atc]") : null;
    var form = button ? button.closest("[data-product-form]") : null;
    if (!isQuickshopForm(form)) return;
    handleQuickshopAtc(form, event);
  }, true);

  document.addEventListener("submit", function(event) {
    var form = event.target;
    if (!isQuickshopForm(form)) return;
    handleQuickshopAtc(form, event);
  }, true);
})(window, document);
